export function cleanFilename(filename: string): string {
    if (filename.includes(".")) {
      return filename.substring(0, filename.lastIndexOf('.'));
    }
    return filename;
  }
  